<template>
	<b-modal @ok="copyHW" @hidden="close" :visible="show" :ok-disabled="selectedPuzzle.length === 0"
		:cancel-disabled="saving" :hide-footer="loading" :title="'modalCopyHomework.title' | translate"
		:ok-title="'modalCopyHomework.submit' | translate" :cancel-title="'modalCopyHomework.cancel' | translate">
		<div v-if="error" class="text-danger">{{ error }}</div>
		<div v-if="loading" class="loader_copy_homework">
			<loader />
		</div>
		<div class="_datepicker" v-else>
			<label>{{ 'modalCopyHomework.label' | translate }}</label>
			<h5 class="slide-title">
				<button @click="changeSlide(-1)" class="btn btn-sm btn-secondary">
					<i class="fa fa-arrow-left" aria-hidden="true" />
				</button>
				<span>{{ 'Slide' | translate }} {{ currentSlide }}</span>
				<button @click="changeSlide(1)" class="btn btn-sm btn-secondary">
					<i class="fa fa-arrow-right" aria-hidden="true" />
				</button>
			</h5>
			<div class="orders">
				<button @click="setSelect(puzzle)" :class="{
					selected: selectedPuzzle.some(
						p => p.order === puzzle && p.month === currentMonth
					),
				}" class="btn-order" v-for="puzzle in availablePuzzles" :key="puzzle">
					<span>{{ puzzle }}</span>
				</button>
			</div>
		</div>
	</b-modal>
</template>

<script>
import Loader from '@/components/Loader'
import { getTime } from '@/helpers/getTime'

export default {
	name: 'modal-copy-homework',
	components: {
		Loader,
	},
	data: () => ({
		currentSlide: null,
		selectedPuzzle: [],
		loading: false,
		saving: false,
		error: '',
		targetDate: '',
	}),
	props: [
		'show',
		'user_id',
		'group_id',
		'homework',
		'disabled_dates',
		'from',
		'slide',
	],
	watch: {
		slide: {
			// watch it
			handler(val, oldVal) { },
			deep: true,
			immediate: true,
		},
		show() {
			this.error = ''
			this.loading = false
			this.saving = false
			this.targetDate = ''
		},
	},
	methods: {
		changeSlide(val) {
			let value = +this.currentSlide + val
			if (value > 64) {
				value = 1
			} else if (value < 1) {
				value = 64
			}
			this.currentSlide = value
		},
		setSelect(order) {
			let newPuzzle = []
			if (
				this.selectedPuzzle.some(
					p => p.order === order && p.month === this.currentMonth
				)
			) {
				newPuzzle = this.selectedPuzzle.filter(p => {
					const isSameOrder = p.order === order
					const isSameMonth = p.month === this.currentMonth
					return !isSameOrder && isSameMonth
				})
			} else {
				newPuzzle = [
					...this.selectedPuzzle,
					{ month: this.currentMonth, year: this.currentYear, order }, // getTime().year
				]
			}
			this.selectedPuzzle = newPuzzle
		},
		close(e) {
			this.$emit('close')
		},
		copyHW(e) {
			if (e) e.preventDefault()
			this.error = ''
			this.saving = true
			const year = this.currentYear //getTime().year
			const month = this.currentMonth - 1 //getTime().month - 1
			this.axios({
				method: 'post',
				url: `lessons/homeworks/${this.homework.id}/copy`,
				data: {
					year,
					orders: this.selectedPuzzle.map(e => ({ ...e, month: e.month - 1 })),
					month,
					// homework: this.homework.id,
					// user: this.user_id ? +this.user_id : null,
					// group: this.group_id ? +this.group_id : null,

					...(this.user_id && { user: +this.user_id }),
					...(this.group_id && { group: +this.group_id })
				},
			})
				.then(() => {
					this.$emit('onSuccessCopy')
					this.saving = false
				})
				.catch(e => {
					this.saving = false
					this.error = e
				})
		},
	},
	mounted() {
		this.currentSlide = this.slide || getTime().month
	},

	computed: {
		availablePuzzles() {
			const puzzles = []
			for (let i = 1; i <= 20; i++) {
				// if (!this.homework.daysDone?.includes(i)) {
				puzzles.push(i)
				// } else if (this.homework.slide !== this.currentSlide) {
				// 	puzzles.push(i)
				// }
			}
			return puzzles
		},
		currentYear() {
			let slideAmount = this.currentSlide
			let result = 2022

			while (slideAmount > 12) {
				slideAmount -= 12
				result += 1
			}

			return result
		},
		currentMonth() {
			let result = this.currentSlide

			while (result > 12) {
				result -= 12
			}

			return result
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.slide-title {
	display: flex;
	justify-content: center;
	align-items: center;

	button {
		margin: 0 10px;
	}
}

._picker {

	.cell.day-header,
	.cell.blank,
	.day.disabled {
		display: none !important;
	}
}

.loader_copy_homework svg {
	display: block;
	margin: auto;
	width: 100px;
	height: 100px;
}

.orders {
	display: grid;
	grid-template-columns: repeat(5, 40px);
	justify-content: center;
	padding: 20px 0;
	gap: 16px;
}

.btn-order {
	font-size: 20px;
	padding: 2px;
	background-color: #fff;
	height: 40px;
	width: 40px;
	border-radius: 10em;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: bold;
	opacity: 0.6;

	outline: none !important;

	@media (max-width: 768px) {
		width: 25px;
		height: 25px;
		font-size: 12px;
	}

	@media (max-width: 380px) {
		width: 16px;
		height: 16px;
		font-size: 9px;
		padding: 1px;
	}

	span {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #212529 !important;
		border: none;
		border-radius: 10em;
		box-shadow: none !important;
		font-weight: normal !important;
	}
}

.selected {
	box-shadow: 2px 2px 0 #6a5ea4;
	opacity: 1;

	span {
		border: 1px dashed #e9407a !important;
		font-weight: bold !important;
	}
}
</style>
